// extracted by mini-css-extract-plugin
module.exports = {"section":"styles_section__3tmtj","name":"styles_name__3fRvJ","submissionCount":"styles_submissionCount__1o27x","arrowRight":"styles_arrowRight__9OfhD"};